import React, { useCallback, useState, useEffect } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from '@mui/material/Card';
import Typography from "@mui/material/Typography";
import MediaCard from "./MediaCard";
import VideoJS from "./VideoJS";

const vids = [
  {
    slug: 'lesson-1',
    name: 'Lesson 1: Foundations',
    media: {
      preview: 'https://d1677ej0by2wqp.cloudfront.net/gud_mc_l1/gud_mc_l1.png',
      src: 'https://d1677ej0by2wqp.cloudfront.net/gud_mc_l1/gud_mc_l1.m3u8'
    }
  }, {
    slug: 'lesson-2',
    name: 'Lesson 2: Basics',
    media: {
      preview: 'https://d1677ej0by2wqp.cloudfront.net/gud_mc_l2/gud_mc_l2.png',
      src: 'https://d1677ej0by2wqp.cloudfront.net/gud_mc_l2/gud_mc_l2.m3u8'
    }
  }, {
    comingSoon: true,
    slug: 'lesson-3',
    name: 'Lesson 3: Dips',
    media: {
      src: 'https://d1677ej0by2wqp.cloudfront.net/fan_dip/fan_dip.m3u8'
    }
  }, {
    comingSoon: true,
    slug: 'lesson-4',
    name: 'Lesson 4: Fanfare',
    media: {
      src: 'https://d1677ej0by2wqp.cloudfront.net/fan_dip/fan_dip.m3u8'
    }
  }, {
    comingSoon: true,
    slug: 'lesson-5',
    name: 'Lesson 5: Advanced moves',
    media: {
      src: 'https://d1677ej0by2wqp.cloudfront.net/fan_dip/fan_dip.m3u8'
    }
  }
]
const vidMap = vids.reduce((acc, curr) => ({ ...acc, [curr.slug]: curr }), {})

function VideosPage(props) {
  // TODO get this from api eventually
  const [videos, setVideos] = useState(vids)
  const [videoId, setVideoId] = useState()

  const playerRef = React.useRef(null);

  useEffect(() => {
    // TODO fetch videos
    const query = new URLSearchParams(window.location.search);
    if (query.get("videoId")) {
      setVideoId(query.get("videoId"))
    }
  }, [])

  const handlePlayerReady = useCallback((player) => {
    console.log('#handlePlayerReady')
    playerRef.current = player;

    // you can handle player events here
    player.on('waiting', () => {
      console.log('player is waiting');
    });

    player.on('dispose', () => {
      console.log('player will dispose');
    });
  }, []);

  if (videoId) {
    if (!vidMap[videoId]) {
      return (
        <Box>
          <Box sx={{ p: 2 }}>
            <Button variant="outlined" color="secondary" href="/">
              <ArrowBackIcon />
              Back
            </Button>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
            <Box sx={{ maxWidth: '1600px', width: '100%' }}>
              <Typography>Video Not Found</Typography>
            </Box>
          </Box>
        </Box>
      )
    }
    const videoJsOptions = { // lookup the options in the docs for more options
      autoplay: true,
      controls: true,
      responsive: true,
      fluid: true,
      sources: [{
        src: vidMap[videoId].media.src,
        type: 'application/x-mpegURL'
      }]
    }
    return (
      <Box sx={{ p: 4 }}>
        <Box>
          <Button variant="outlined" color="secondary" href="/">
            <ArrowBackIcon />
            Back
          </Button>
        </Box>
        <Box sx={{ my: 2 }}>
          <Typography variant="h4">{vidMap[videoId].name}</Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ maxWidth: '1600px', width: '100%' }}>
            <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
          </Box>
        </Box>
      </Box>
    )
  }
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
      <Card sx={{ width: '100%', maxWidth: '1200px' }}>
        <Box sx={{ p: 3 }}>
          <Typography variant='h4' >Welcome to Giddyup Dance</Typography>
          <Typography variant='h6' >Ready to kick off your swing dance journey?</Typography>
          <Box sx={{ pt: 6, display: 'flex', flexWrap: 'wrap' }}>
            {
              videos.map(({ comingSoon, media, name, slug }) => (
                <Box sx={{ m: 2, width: 320 }} key={slug}>
                  <Box component="a" href={`/?videoId=${slug}`} sx={{ textDecoration: 'none' }}>
                    <MediaCard title={name} description={''} media={{ image: media.preview, alt: name }} comingSoon={comingSoon} />
                  </Box>
                </Box>
              ))
            }
          </Box>
        </Box>
      </Card>
    </Box>
  )
};

export default VideosPage